import React, { Component } from 'react';

export default class FadeIn extends Component {
	constructor(props) {
		super(props);
		this.state = { displayChildren: false };
	}

	componentDidMount() {
		let time = this.props.timeout ? this.props.timeout : 100; 
		setTimeout(() => {
			this.setState({ displayChildren: true });
		}, time);
	}

	render() {
		let displayChildren = this.props.hasOwnProperty('show') ? 
			this.props.show 
			: 
			this.state.displayChildren || this.props.timeout === 0;

		let addedClass = this.props.addedClass ? " " + this.props.addedClass : "";

		return (
			<div className={"transition-fade-in" + (displayChildren ? " show" : "") + addedClass}>
				{ this.props.children } 
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/global/FadeIn.js